import theme from '../app.json'

let Apps = {}

switch (theme.themename) {
  default:
    // @ts-ignore
    Apps[theme.themename] = import('../../src/themes/thema1/App')
    break
}

export default Apps
